import React from 'react'
import {BrowserBarcodeReader, DecodeHintType, BarcodeFormat} from '@zxing/library'

import {Alert, Caption, Spinner} from '../../src/components/UI/index.js'

class ScanXzing extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            videoLoading: false
        }

        const hints = new Map()
        hints.set(DecodeHintType.POSSIBLE_FORMATS, [BarcodeFormat.CODE_39, BarcodeFormat.CODE_128, BarcodeFormat.EAN_8, BarcodeFormat.EAN_13])
        // hints.set(DecodeHintType.TRY_HARDER, true)
        this.codeReader = new BrowserBarcodeReader(300, hints)
    }

    componentWillUnmount() {
        const video = document.getElementById('video')
        const stream = video?.srcObject
        const tracks = stream?.getTracks()

        if (tracks) {
            tracks.forEach((track) => {
                track.stop()
            })

            video.srcObject = null
        }

        this.codeReader.reset()
    }

    async startVideo(deviceId) {
        this.setState({videoLoading: true})

        await this.codeReader.decodeFromVideoDevice(deviceId, 'video', this.scan.bind(this)).catch((err) => {
            this.props.onError(err)
        })

        this.setState({videoLoading: false})
    }

    scan(result) {
        if (result?.text) {
            this.props.onScan(result.text)
        }
    }

    render() {
        const {videoLoading, error} = this.state
        const {maxHeight} = this.props

        return (
            <div style={{display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center', justifyContent: 'center'}}>
                {videoLoading && <Spinner />}

                <video id='video' style={{height: maxHeight || 'calc(50vh - 170px)', width: '100%', objectFit: 'cover'}}></video>

                <Caption style={{width: '100%', marginBottom: 12, marginTop: 3, marginLeft: 3}}>zxing-js 0.19.1</Caption>

                {error && !error.err &&
                    <Alert style={{marginBottom: 6}} variant='error'>{error}</Alert>
                }

                {error && error.err &&
                    <Alert style={{marginBottom: 6}} variant='errorHandler' err={error.err} customMessage={error.customMessage} />
                }
            </div>
        )
    }
}

export default ScanXzing
